import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class NahlasenieNegenerovaneSpravy extends Component {
    lastSelectedIndex = 0;
    state = {
        loading: false
    };

    changeSelectedItemId = (e) => {
        var items = this.props.items;

        let last = this.lastSelectedIndex;
        const current = items.findIndex((dataItem) => dataItem === e.dataItem);

        if (!e.nativeEvent.shiftKey) {
            this.lastSelectedIndex = last = current;
        }

        if (!e.nativeEvent.ctrlKey) {
            items.forEach((item) => (item.selected = false));
        }
        const select = !e.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            items[i].selected = select;
        }
        this.props.changeSelectedItemIds(items.filter((dataItem) => dataItem.selected).map((a) => a.idnahlasenie));

        this.forceUpdate();
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="NegenerovaneSpravy" onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid data={items} selectedField="selected" onRowClick={this.changeSelectedItemId}>
                    <GridColumn
                        field="idnahlasenie"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.IDNahlasenie", "IDNahlasenie")}
                    />
                    <GridColumn field="iddodavka" title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.IDDodavka", "IDDodavka")} />
                    <GridColumn
                        field="cisloDodavky"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Číslo dodávky", "Číslo dodávky")}
                        width="70px"
                    />
                    <GridColumn field="ciarovyKod" title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Čárový kód", "Čárový kód")} />
                    <GridColumn
                        field="skratkaFrom"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Odosielateľ", "Odosielateľ")}
                    />
                    <GridColumn field="skratkaTo" title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Príjemca", "Príjemca")} />
                    <GridColumn
                        field="dodávkaTypTovaru"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Typ tovaru", "Typ tovaru")}
                        width="70px"
                    />
                    <GridColumn
                        field="pocetBalikov"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Balíkov", "Balíkov")}
                        width="70px"
                    />
                    <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Kusov", "Kusov")} width="70px" />
                    <GridColumn
                        field="datumPrijatiaTovaru"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Prijetí tovaru", "Prijetí tovaru")}
                        format="{0:d.M.yyyy H:mm}"
                    />
                    <GridColumn
                        field="datumNahlasenia"
                        title={localizationService.toLanguageString("NahlasenieNegenerovaneSpravy.Grid.Nahlásenie", "Nahlásenie")}
                        format="{0:d.M.yyyy H:mm}"
                    />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.props.items);

        return <div>{contents}</div>;
    }
}

export default NahlasenieNegenerovaneSpravy;

registerForLocalization(NahlasenieNegenerovaneSpravy);



// WEBPACK FOOTER //
// ./src/components/views/Tools/NahlasenieNegenerovaneSpravy.js